import React from "react";
import { Box } from "@mui/material";
import Profile from "./profile";
import PortfolioSummary from "components/portfolioSummary";

const HeaderContent = () => {
  return (
    <>
      <Box sx={{ ml: 1, overflow: "hidden", flex: 1, minWidth: 0 }}>
        <PortfolioSummary />
      </Box>
      <Profile />
    </>
  );
};

export default HeaderContent;
